<div class="panel_container">
  <div class="detail_evt_fermer">
    <button
      type="button"
      appButton
      variant="ghost"
      iconOnly
      icon="x"
      class="btn_fermer"
      label="Fermer le panneau"
      (click)="fermerSlider()"
    ></button>
  </div>

  <h2>Sélectionner un ou plusieurs évènements</h2>
  <div class="evenement_select">
    <!-- `app-select` travaille sur des CLÉS : l'identifiant Aparté sert de clé et les
         états (« acompte fait », « déjà paramétré ») passent par le `suffix` de l'option,
         là où Material imbriquait des `mat-chip` dans le contenu de l'option. -->
    <app-form-field label="Évènements">
      <app-select
        label="Sélectionner des évènements"
        trigger="field"
        selectionMode="multi"
        [fullWidth]="true"
        [clearable]="true"
        [options]="optionsEvenements()"
        [selected]="evenementsSelectionnesCles()"
        (selectionChange)="choisirEvenements($event)"
      />
    </app-form-field>
  </div>

  @if (evenementsSelectionnesClesSource()?.length) {
    <h2>Évènement(s) sélectionné(s)</h2>
    <div class="evenement_selection">
      <ul class="liste_selection" role="list">
        @for (evt of evenementsSelectionnesClesSource() ?? []; track evt.idEvenement) {
          <li class="evenement_selection_element">
            {{ evt.idAparte }} - {{ evt.nomEvenement }} du {{ evt.dateEvenement | date: 'dd/MM/yyyy' }}
            @if (evt.parametrageSpecifique) {
              <app-pill label="déjà un paramétrage spécifique" tone="warning" />
            }
            <button
              type="button"
              appButton
              variant="ghost"
              size="sm"
              iconOnly
              icon="x"
              label="Retirer de la sélection"
              appTooltip="Retirer de la sélection"
              (click)="retirerEvenementDeLaSelection(evt)"
            ></button>
          </li>
        }
      </ul>
    </div>

    <div class="regle_container">
      <form [formGroup]="reglesForm">
        <h2>Sélectionner une règle</h2>
        <div class="regle_card">
          <h4>Pour les places</h4>
          <div class="regle_form_row" formGroupName="reglePourPlaces">
            <app-form-field label="Pourcentage à appliquer" class="dialog_form_field">
              <app-input
                inputMode="decimal"
                [allowedChars]="chiffres"
                suffix="%"
                formControlName="pourcentage"
                (committed)="normaliserTaux(reglesForm.controls.reglePourPlaces.controls.pourcentage)"
              />
              @if (pourcentageHorsBornes()) {
                <span appFieldError>Un pourcentage entre 0 et 100</span>
              }
            </app-form-field>
            <app-form-field label="Montant à appliquer" class="dialog_form_field">
              <app-input
                inputMode="decimal"
                [allowedChars]="chiffres"
                suffix="€"
                formControlName="minimum"
                (committed)="normaliserMontant(reglesForm.controls.reglePourPlaces.controls.minimum)"
              />
            </app-form-field>
          </div>
          @if (regles().reglePourPlaces?.minimum) {
            <div class="preview">
              {{ reglePourPlacesLibelle() }}
            </div>
          }
        </div>
      </form>
    </div>
  }

  <div class="footer_container">
    <button type="button" appButton variant="secondary" (click)="fermerSlider()">Annuler</button>
    <button type="button" appButton variant="primary" [disabled]="!reglesValides()" (click)="valider()">Valider</button>
  </div>
</div>
